export const QRULES_ERROR_NAME = 'qrules.error';

export const ERROR_FAILED_TO_SELECT_SOURCE = 'Failed to select the source node.';
export const ERROR_FAILED_TO_SELECT_DESTINATION = 'Failed to select the destination node.';

export const ERROR_INVALID_FILE_NAME_NODE = 'Invalid file name node XPath.';

export const ERROR_REMOVE_PI_NOT_FOUND = 'The specified processing instruction was not found.';
